import { MagicConfigMixin, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Emit, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let TermsUpdatedPromptComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isLoading = false;
  }
  get updatedSummaries() {
    return this.consents.map(({ consentContents }) => {
      return consentContents.content;
    });
  }
  decline() {
    if (this.isLoading) {
      return;
    }
    this.routeTo({ route: RoutablePage.ACCOUNT_CLOSURE });
  }
  agree() {
    return __async(this, null, function* () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      try {
        yield magic.methods.users.saveUserConsents(this.consents.map((consent) => __spreadProps(__spreadValues({}, consent), {
          consented: true
        })));
        notificationService.show(this.$t("terms-updated.updated"), {
          style: NotificationStyle.SUCCESS
        });
        this.closeAndAccept();
      } catch (e) {
        console.error(e);
        notificationService.show(this.$t("terms-updated.unexpected-error"), {
          style: NotificationStyle.ERROR
        });
      } finally {
        this.isLoading = false;
      }
    });
  }
  closeAndAccept() {
    return;
  }
};
__decorateClass([
  Prop({
    type: Array,
    default: []
  })
], TermsUpdatedPromptComponent.prototype, "consents", 2);
__decorateClass([
  Emit("acceptedTerms")
], TermsUpdatedPromptComponent.prototype, "closeAndAccept", 1);
TermsUpdatedPromptComponent = __decorateClass([
  Component({
    name: "terms-updated-prompt"
  })
], TermsUpdatedPromptComponent);

export default TermsUpdatedPromptComponent;
